// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` /*
 Copyright (c) 2023 Quantellia LLC
 All Rights Reserved
 */
/* From https://codepen.io/Bilal1909/pen/pobgJae */
bodY {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.outer-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  width: 96px;
  height: 96px;
}

.centerwave {
  /* height: 101vh; */
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  width: 96px;
  height: 96px;
}

.scale-wrapper {
  transform-origin: top;
  transform: scale(0.3); /* Adjust the scale factor as needed */
  width: 30%;
  height: 80pt;
}

.wave-wrapper {
  display: flex;
  justify-content: center;
  align-items: flex-end; /* Adjust alignment as needed */
  width: 100%;
  height: 100%;
}

.wave {
  width: 5px;
  height: 100px;
  background: linear-gradient(45deg, purple, #fff);
  margin: 10px;
  animation: wave 1s linear infinite;
  border-radius: 20px;
}

.wave:nth-child(2) {
  animation-delay: 0.1s;
}
.wave:nth-child(3) {
  animation-delay: 0.2s;
}
.wave:nth-child(4) {
  animation-delay: 0.3s;
}
.wave:nth-child(5) {
  animation-delay: 0.4s;
}
.wave:nth-child(6) {
  animation-delay: 0.5s;
}
.wave:nth-child(7) {
  animation-delay: 0.6s;
}
.wave:nth-child(8) {
  animation-delay: 0.7s;
}
.wave:nth-child(9) {
  animation-delay: 0.8s;
}
.wave:nth-child(10) {
  animation-delay: 0.9s;
}

@keyframes wave {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
`, "",{"version":3,"sources":["webpack://./css/loading-animation.css"],"names":[],"mappings":"CAAC;;;EAGC;AACF,kDAAkD;AAClD;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,qBAAqB,EAAE,sCAAsC;EAC7D,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB,EAAE,+BAA+B;EACtD,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[" /*\r\n Copyright (c) 2023 Quantellia LLC\r\n All Rights Reserved\r\n */\r\n/* From https://codepen.io/Bilal1909/pen/pobgJae */\r\nbodY {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.outer-wrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background: white;\r\n  width: 96px;\r\n  height: 96px;\r\n}\r\n\r\n.centerwave {\r\n  /* height: 101vh; */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background: white;\r\n  width: 96px;\r\n  height: 96px;\r\n}\r\n\r\n.scale-wrapper {\r\n  transform-origin: top;\r\n  transform: scale(0.3); /* Adjust the scale factor as needed */\r\n  width: 30%;\r\n  height: 80pt;\r\n}\r\n\r\n.wave-wrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: flex-end; /* Adjust alignment as needed */\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.wave {\r\n  width: 5px;\r\n  height: 100px;\r\n  background: linear-gradient(45deg, purple, #fff);\r\n  margin: 10px;\r\n  animation: wave 1s linear infinite;\r\n  border-radius: 20px;\r\n}\r\n\r\n.wave:nth-child(2) {\r\n  animation-delay: 0.1s;\r\n}\r\n.wave:nth-child(3) {\r\n  animation-delay: 0.2s;\r\n}\r\n.wave:nth-child(4) {\r\n  animation-delay: 0.3s;\r\n}\r\n.wave:nth-child(5) {\r\n  animation-delay: 0.4s;\r\n}\r\n.wave:nth-child(6) {\r\n  animation-delay: 0.5s;\r\n}\r\n.wave:nth-child(7) {\r\n  animation-delay: 0.6s;\r\n}\r\n.wave:nth-child(8) {\r\n  animation-delay: 0.7s;\r\n}\r\n.wave:nth-child(9) {\r\n  animation-delay: 0.8s;\r\n}\r\n.wave:nth-child(10) {\r\n  animation-delay: 0.9s;\r\n}\r\n\r\n@keyframes wave {\r\n  0% {\r\n    transform: scale(0);\r\n  }\r\n  50% {\r\n    transform: scale(1);\r\n  }\r\n  100% {\r\n    transform: scale(0);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
